/* eslint-disable import/no-named-default */
/* eslint-disable camelcase */
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import uiEn from './en/ui.json';
import uiEs from './es/ui.json';

i18n
  .use(LanguageDetector)
  // .use(XHR)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    fallbackLng: 'en',
    resources: {
      en: { ui: uiEn },
      es: { ui: uiEs },
      ca: { ui: uiEs },
      eu: { ui: uiEs },
      gl: { ui: uiEs },
      vl: { ui: uiEs },
    },
    defaultNS: 'ui', // default namespace
    keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
